// import {
//   Alert,
//   Button,
//   Divider,
//   IconButton,
//   Snackbar,
//   TextField,
// } from "@mui/material";
// import React, { useEffect, useState } from "react";

// import LocalOfferIcon from "@mui/icons-material/LocalOffer";
// import { teal } from "@mui/material/colors";
// import FavoriteIcon from "@mui/icons-material/Favorite";
// import CartItemCard from "./CartItemCard";
// import { useNavigate } from "react-router-dom";
// import PricingCard from "./PricingCard";
// import { useAppDispatch, useAppSelector } from "../../../Redux Toolkit/Store";
// import { fetchUserCart } from "../../../Redux Toolkit/Customer/CartSlice";
// import { CartItem } from "../../../types/cartTypes";
// import { applyCoupon } from "../../../Redux Toolkit/Customer/CouponSlice";
// import CloseIcon from "@mui/icons-material/Close";
// import { Close } from "@mui/icons-material";

// const Cart = () => {
//   const navigate = useNavigate();
//   const dispatch = useAppDispatch();
//   const { cart, auth, coupone } = useAppSelector((store) => store);
//   const [couponCode, setCouponCode] = useState("");
//   const [snackbarOpen, setOpenSnackbar] = useState(false);

//   useEffect(() => {
//     dispatch(fetchUserCart(localStorage.getItem("jwt") || ""));
//   }, [auth.jwt]);

//   const handleChange = (e: any) => {
//     setCouponCode(e.target.value);
//   };

//   const handleApllyCoupon = (apply: string) => {
//     // console.log(couponCode,apply)

//     var code = couponCode;

//     if (apply == "false") {
//       code = cart.cart?.couponCode || "";
//     }

//     dispatch(
//       applyCoupon({
//         apply,
//         code,
//         orderValue: cart.cart?.totalSellingPrice || 100,
//         jwt: localStorage.getItem("jwt") || "",
//       })
      
//     ) .then(() => dispatch(fetchUserCart(localStorage.getItem("jwt") || "")));;
//   };
//   const handleCloseSnackbar = () => {
//     setOpenSnackbar(false);
//   };

//   useEffect(() => {
//     if (coupone.couponApplied || coupone.error) {
//       setOpenSnackbar(true);
//       setCouponCode("");
      
//       // Refresh cart so PricingCard sees updated totals/discounts
//       if (coupone.couponApplied) {
//       dispatch(fetchUserCart(localStorage.getItem("jwt") || ""));
//     }
//     }
//   }, [coupone.couponApplied, coupone.error]);

//   console.log("cart ", coupone);
//   return (
//     <>
//       {cart.cart && cart.cart?.cartItems.length !== 0 ? (
//         <div className="pt-10 px-5 sm:px-10 md:px-60 lg:px-60 min-h-screen">
//           <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 ">
//             <div className="lg:col-span-2 space-y-3 ">
//               {cart.cart?.cartItems.map((item: CartItem) => (
//                 <CartItemCard key={item.id} item={item} />
//               ))}
//             </div>

//             <div className="col-span-1  text-sm space-y-3">
//               <div className="border rounded-md px-5 py-3 space-y-5">
//                 <div className="">
//                   <div className="flex gap-3 text-sm items-center">
//                     <LocalOfferIcon
//                       sx={{ color: teal[600], fontSize: "17px" }}
//                     />
//                     <span>Apply Coupon</span>
//                   </div>
//                 </div>
//                 {!cart.cart?.couponCode ? (
//                   <div className="flex justify-between items-center">
//                     <TextField
//                       value={couponCode}
//                       onChange={handleChange}
//                       placeholder="coupon code"
//                       className=""
//                       size="small"
//                     />
//                     <Button
//                       onClick={() => handleApllyCoupon("true")}
//                       disabled={couponCode ? false : true}
//                       size="small"
//                     >
//                       APPLY
//                     </Button>
//                   </div>
//                 ) : (
//                   <div className="flex">
//                     <div className="p-1 pl-5 pr-3 border rounded-full flex gap-2 items-center">
//                       <span className="">{cart.cart.couponCode} Applied</span>
//                       <IconButton
//                         onClick={() => handleApllyCoupon("false")}
//                         size="small"
//                       >
//                         <Close className="text-red-600" />
//                       </IconButton>
//                     </div>
//                   </div>
//                 )}
//               </div>

//               <section className="border rounded-md">
//                 <PricingCard />
//                 <div className="p-5">
//                   <Button
//                     onClick={() => {
//                       const totalSellingPrice = cart.cart?.totalSellingPrice || 0;
//                       const isFreeShipping = totalSellingPrice > 1499;
//                       const shippingFee = isFreeShipping ? 0 : 95;
//                       const finalTotal = totalSellingPrice + shippingFee;
//                       navigate("/checkout/address",{ state: { finalTotal } })}
//                     }
//                     sx={{ py: "11px" }}
//                     variant="contained"
//                     fullWidth
//                   >
//                     BUY NOW
//                   </Button>
//                 </div>
//               </section>

//               <div className="border rounded-md px-5 py-4 flex justify-between items-center cursor-pointer">
//                 <span>Add From Whishlist</span>
//                 <FavoriteIcon sx={{ color: teal[600], fontSize: "21px" }} />
//               </div>
//             </div>
//           </div>
//         </div>
//       ) : (
//         <div className="h-[85vh] flex justify-center items-center flex-col">
//           <div className="text-center py-5">
//             <h1 className="text-lg font-medium">Hey it's feels so light!</h1>
//             <p className="text-gray-500 text-sm">
//               there is nothing in your bag, lets add some items
//             </p>
//           </div>
//           <Button variant="outlined" sx={{ py: "11px" }}>
//             Add Item From Wishlist
//           </Button>
//         </div>
//       )}
//       <Snackbar
//         anchorOrigin={{ vertical: "top", horizontal: "right" }}
//         open={snackbarOpen}
//         autoHideDuration={6000}
//         onClose={handleCloseSnackbar}
//       >
//         <Alert
//           onClose={handleCloseSnackbar}
//           severity={coupone.error ? "error" : "success"}
//           variant="filled"
//           sx={{ width: "100%" }}
//         >
//           {coupone.error ? coupone.error : "Coupon Applied successfully"}
//         </Alert>
//       </Snackbar>
//     </>
//   );
// };

// export default Cart;


import {
  Alert,
  Button,
  Divider,
  IconButton,
  Snackbar,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";

import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import { teal } from "@mui/material/colors";
import FavoriteIcon from "@mui/icons-material/Favorite";
import CartItemCard from "./CartItemCard";
import { useNavigate } from "react-router-dom";
import PricingCard from "./PricingCard";
import { useAppDispatch, useAppSelector } from "../../../Redux Toolkit/Store";
import { fetchUserCart } from "../../../Redux Toolkit/Customer/CartSlice";
import { CartItem } from "../../../types/cartTypes";
import { applyCoupon } from "../../../Redux Toolkit/Customer/CouponSlice";
import CloseIcon from "@mui/icons-material/Close";
import { Close } from "@mui/icons-material";
import { trackEvent } from "../../../util/analytics";

const Cart = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { cart, auth, coupone } = useAppSelector((store) => store);
  const [couponCode, setCouponCode] = useState("");
  const [snackbarOpen, setOpenSnackbar] = useState(false);

  useEffect(() => {
    trackEvent("CART_VIEW", {
      page: "/cart",
    });
  }, []);

  useEffect(() => {
    dispatch(fetchUserCart(localStorage.getItem("jwt") || ""));
  }, [auth.jwt]);

  const handleChange = (e: any) => {
    setCouponCode(e.target.value);
  };

  const handleApllyCoupon = (apply: string) => {
    // console.log(couponCode,apply)

    var code = couponCode;

    if (apply == "false") {
      code = cart.cart?.couponCode || "";
    }

    dispatch(
      applyCoupon({
        apply,
        code,
        orderValue: cart.cart?.totalSellingPrice || 100,
        jwt: localStorage.getItem("jwt") || "",
      })
      
    ) .then(() => dispatch(fetchUserCart(localStorage.getItem("jwt") || "")));;
  };
  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  useEffect(() => {
    if (coupone.couponApplied || coupone.error) {
      setOpenSnackbar(true);
      setCouponCode("");
      
      // Refresh cart so PricingCard sees updated totals/discounts
      if (coupone.couponApplied) {
      dispatch(fetchUserCart(localStorage.getItem("jwt") || ""));
    }
    }
  }, [coupone.couponApplied, coupone.error]);

  console.log("cart ", coupone);
  return (
    <>
      {cart.cart && cart.cart?.cartItems.length !== 0 ? (
        <div className="pt-10 px-5 sm:px-10 md:px-60 lg:px-60 min-h-screen">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 ">
            <div className="lg:col-span-2 space-y-3 ">
              {cart.cart?.cartItems.map((item: CartItem) => (
                <CartItemCard key={item.id} item={item} />
              ))}
            </div>

            <div className="col-span-1  text-sm space-y-3">
              <div className="border rounded-md px-5 py-3 space-y-5">
                <div className="">
                  <div className="flex gap-3 text-sm items-center">
                    <LocalOfferIcon
                      sx={{ color: teal[600], fontSize: "17px" }}
                    />
                    <span>Apply Coupon</span>
                  </div>
                </div>
                {!cart.cart?.couponCode ? (
                  <div className="flex justify-between items-center">
                    <TextField
                      value={couponCode}
                      onChange={handleChange}
                      placeholder="coupon code"
                      className=""
                      size="small"
                    />
                    <Button
                      onClick={() => handleApllyCoupon("true")}
                      disabled={couponCode ? false : true}
                      size="small"
                    >
                      APPLY
                    </Button>
                  </div>
                ) : (
                  <div className="flex">
                    <div className="p-1 pl-5 pr-3 border rounded-full flex gap-2 items-center">
                      <span className="">{cart.cart.couponCode} Applied</span>
                      <IconButton
                        onClick={() => handleApllyCoupon("false")}
                        size="small"
                      >
                        <Close className="text-red-600" />
                      </IconButton>
                    </div>
                  </div>
                )}
              </div>

              <section className="border rounded-md">
                <PricingCard />
                <div className="p-5">
                  <Button
                    onClick={() => {
                      const totalSellingPrice = cart.cart?.totalSellingPrice || 0;
                      const isFreeShipping = totalSellingPrice > 1499;
                      const shippingFee = isFreeShipping ? 0 : 95;
                      const finalTotal = totalSellingPrice + shippingFee;
                      navigate("/checkout/address",{ state: { finalTotal } })}
                    }
                    sx={{ py: "11px" }}
                    variant="contained"
                    fullWidth
                  >
                    BUY NOW
                  </Button>
                </div>
              </section>

              <div className="border rounded-md px-5 py-4 flex justify-between items-center cursor-pointer">
                <span>Add From Whishlist</span>
                <FavoriteIcon sx={{ color: teal[600], fontSize: "21px" }} />
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="h-[85vh] flex justify-center items-center flex-col">
          <div className="text-center py-5">
            <h1 className="text-lg font-medium">Hey it's feels so light!</h1>
            <p className="text-gray-500 text-sm">
              there is nothing in your bag, lets add some items
            </p>
          </div>
          <Button variant="outlined" sx={{ py: "11px" }}>
            Add Item From Wishlist
          </Button>
        </div>
      )}
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={coupone.error ? "error" : "success"}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {coupone.error ? coupone.error : "Coupon Applied successfully"}
        </Alert>
      </Snackbar>
    </>
  );
};

export default Cart;